var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"value":_vm.isLoading,"z-index":"990"}},[_c('v-progress-circular',{attrs:{"size":50,"color":"var(--color__primary)","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }